// extracted by mini-css-extract-plugin
module.exports = {"overlay":"UnableToUpgradeDialog_overlay__Mzd1h"};